<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { required, sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useAuthStore } from '@/stores/useAuthStore'
import SSNInput from '../../Shared/SSNInput.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()
const authStore = useAuthStore()

const props = defineProps<{
  disable?: boolean
}>()

const rules = {
  umsokn: {
    employeeName: { required },
    employeeSsn: { required },
    employeeEmail: { required },
    witholdSalary: { sameAs: sameAs(true) }
  }
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <!-- Header -->
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('sereignar_umsokn_step3_header') }}
        </h2>
      </v-col>
    </v-row>

    <!-- Name + SSN -->
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="umsokn.employeeName"
          :label="t('sereignar_umsokn_step3_nafn')"
          :readonly="props.disable"
          variant="outlined"
          density="comfortable"
          :error="v$.umsokn.employeeName.$error"
          :error-messages="v$.umsokn.employeeName.$error ? [t('sereignar_umsokn_step3_nafn_error')] : []"
        />
      </v-col>
      <v-col cols="12" md="6">
        <SSNInput
          v-model="umsokn.employeeSsn"
          :label="t('sereignar_umsokn_step3_ssn')"
          :readonly="props.disable"
          variant="outlined"
          density="comfortable"
          v-mask="'######-####'"
          :error="v$.umsokn.employeeSsn.$error"
          :error-messages="v$.umsokn.employeeSsn.$error ? [t('sereignar_umsokn_step3_ssn_error')] : []"
        />
      </v-col>
    </v-row>

    <!-- Netfang launadeildar -->
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="umsokn.employeeEmail"
          :label="t('sereignar_umsokn_step3_netfang_launadeildar')"
          :readonly="props.disable"
          variant="outlined"
          density="comfortable"
          :error="v$.umsokn.employeeEmail.$error"
          :error-messages="v$.umsokn.employeeEmail.$error ? [t('sereignar_umsokn_step3_netfang_launadeildar_error')] : []"
        />
      </v-col>
    </v-row>

    <!-- Withhold salary -->
    <v-row>
      <v-col>
        <v-checkbox
          v-model="umsokn.witholdSalary"
          :readonly="props.disable"
          :label="t('sereignar_umsokn_step3_halda_launum')"
          :error="v$.umsokn.witholdSalary.$error"
          :error-messages="v$.umsokn.witholdSalary.$error ? [t('sereignar_umsokn_step3_halda_launum_error')] : []"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
h2.form__header {
  margin-bottom: 20px;
}
</style>
